import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomerType = ({ onChange }) => {
  const { t } = useTranslation();

  const customerTypes = [
    { key: 'individual', label: t('customer.type.individual') },
    { key: 'company', label: t('customer.type.company') },
    { key: 'sole-proprietorship', label: t('customer.type.sole_proprietorship') },
  ];

  return (
    <div className='customer_type'>
      {customerTypes.map((customerType) => (
        <div
          key={customerType.key}
          className={`customer_type__item item--${customerType.key}`}
          onClick={() => onChange(customerType.key)}>
          {customerType.label}
        </div>
      ))}
    </div>
  );
};

export default CustomerType;
